export const AUTH_COOKIES_NAME = 'russianhackers.org';
export const TOASTR_POSITION = 'bottom-right';
export const ADD_HACKATHON_URL = '/add_hackathon';
export const POSSIBLE_TECHNOLOGIES = [
  'Python',
  'C#',
  'Google TensonFlow',
  'C++',
  'C+',
  'Cobalt',
  'CSS',
];


// WEBPACK FOOTER //
// ./src/constants/configuration.js